import {
  IS_IE_BROWSER,
} from '../../common/config';

export class AudioViewerService {

  constructor(
    $timeout,
    $rootScope,
    LayoutService,
  ) {
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.maxSize = LayoutService.options.wavesurferMaxSize.value;

  }

  get currentFact() {
    return this._currentFact;
  }

  set currentFact(fact) {
    if (this._currentFact && this._currentFact.audio) {
      this._currentFact.audio.removeEventListener('ended', this.playNextAudio);
    }
    this._currentFact = fact;
    if (this._currentFact.audio) {
      this._currentFact.audio.addEventListener('ended', this.playNextAudio);
    }
  }

  isWaves(fact) {
    return !IS_IE_BROWSER && fact && fact.fileSize != undefined && fact.fileSize < this.maxSize;
  }

  get isPlaying() {
    if (this.isWaves(this.currentFact)) {
      return this.currentFact.wavesurfer && this.currentFact.wavesurfer.isPlaying();
    } else if (this.currentFact.audio) {
      return this.currentFact.audio &&
        this.currentFact.audio.currentTime > 0 &&
        !this.currentFact.audio.paused && !this.currentFact.audio.ended &&
        this.currentFact.audio.readyState > 2;
    }
    return false;
  }

  playPause() {
    if (this.isWaves(this.currentFact) && this.currentFact.wavesurfer && this.currentFact.wavesurfer.backend) {
      this.currentFact.wavesurfer.playPause();
    } else if (this.currentFact.audio) {
      if (!this.isPlaying) {
        this.currentFact.audio.play();
      } else {
        this.currentFact.audio.pause();
      }
    }
  }

  play(fact, progress) {
    if (this.currentFact === fact) {
      this.playPause();
      return;
    } else {
      if (this.currentFact && this.isPlaying) {
        this.playPause();
      }
    }
    this.currentFact = fact;
    if (this.isWaves(fact)) {
      if (progress !== undefined) fact.wavesurfer.seekTo(progress);
    }
    this.$timeout(() => {
      this.playPause();
    }, 100);
  }

}



// WEBPACK FOOTER //
// ./src/facts/audio-waves/audio-viewer.service.js